import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PrivacyPage = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <section className="py-16 md:py-20 bg-gradient-to-r from-blue-900 to-blue-800 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-blue-200">Last updated: March 2026</p>
      </div>
    </section>

    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 prose prose-lg max-w-none text-gray-700 space-y-8">
      <motion.section initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
        <p className="leading-relaxed">
          Arabian Link Doors (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) respects your privacy. This policy explains how we collect,
          use, and protect personal information when you visit our website or use our contact and newsletter forms.
        </p>
      </motion.section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Contact form:</strong> name, email, phone, company, service interest, message, and urgency level.</li>
          <li><strong>Newsletter:</strong> email address when you subscribe to industry updates.</li>
          <li><strong>Technical data:</strong> basic usage data such as browser type and pages visited (via standard web server logs).</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Your Information</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Respond to inquiries and provide quotes or support.</li>
          <li>Send industry updates if you subscribed to our newsletter.</li>
          <li>Improve our website and services.</li>
          <li>Comply with legal obligations where applicable.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Data Storage & Retention</h2>
        <p className="leading-relaxed mb-3">
          Contact submissions are stored securely in our database and automatically deleted after approximately 90 days.
          Newsletter subscriptions are retained until you unsubscribe or request removal.
          Industry updates displayed on our website may be removed from our database after approximately 90 days.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Third-Party Services</h2>
        <p className="leading-relaxed">
          We use trusted providers to operate our website, including MongoDB (data storage), Resend (email delivery),
          and hosting on Vercel. These providers process data only as needed to perform their services.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Your Rights</h2>
        <p className="leading-relaxed">
          You may request access, correction, or deletion of your personal data by contacting us at{' '}
          <a href="mailto:arabianlinkdoors@gmail.com" className="text-blue-600 hover:underline">arabianlinkdoors@gmail.com</a>.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact</h2>
        <p className="leading-relaxed">
          Arabian Link Doors — Sharjah, UAE<br />
          Email: arabianlinkdoors@gmail.com<br />
          Phone: +971 50 494 6149
        </p>
        <p className="mt-6">
          <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
        </p>
      </section>
    </div>
  </div>
);

export default PrivacyPage;
